import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";

interface Props {
  eyebrow?: string;
  title: string;
  body?: string;
}

export const CtaBand = ({ eyebrow = "— Nästa steg", title, body }: Props) => (
  <section className="py-20 md:py-28 bg-primary text-primary-foreground">
    <div className="container-page">
      <div className="grid gap-12 md:grid-cols-12 items-end">
        <div className="md:col-span-8">
          <div className="inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.24em] text-primary-foreground/85">
            {eyebrow}
          </div>
          <h2 className="display-lg mt-6 text-primary-foreground text-balance">
            {title.split(" ").slice(0, -2).join(" ")}{" "}
            <span className="italic text-accent">{title.split(" ").slice(-2).join(" ")}</span>
          </h2>
          {body && <p className="mt-8 max-w-xl text-lg text-primary-foreground/90 leading-relaxed font-light">{body}</p>}
        </div>
        <div className="md:col-span-4 flex flex-col items-start md:items-end gap-5">
          <Link
            to="/kontakt-umea"
            className="inline-flex items-center gap-3 rounded-full bg-accent px-7 py-3.5 text-sm font-medium text-accent-foreground transition-all hover:bg-primary-foreground hover:text-primary"
          >
            Boka kostnadsfri rådgivning
            <ArrowRight className="h-4 w-4" />
          </Link>
          <a href="tel:0703036345" className="inline-flex items-center gap-2 text-sm text-primary-foreground/90 hover:text-accent transition-colors">
            <Phone className="h-3.5 w-3.5" /> 070-303 63 45
          </a>
        </div>
      </div>
    </div>
  </section>
);
